// Libraries
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import useTopNavItems from 'src/components/Header/TopNavHeader/TopNavItemsV2/hooks/useTopNavItems';
// Components
import { Grid } from 'src/components/HTKit/Grid';
import NavHeader from 'src/components/Header/TopNavHeader/TopNavItemsV2/NavHeader';
import PrimaryMenu from 'src/components/Header/TopNavHeader/TopNavItemsV2/PrimaryMenu';
import SecondaryMenu from 'src/components/Header/TopNavHeader/TopNavItemsV2/SecondaryMenu';
// Styles
import styles from './styles.scss';

const TopNavItems = ({ skuCategoriesAndSkus, toggleTopnav, skuLinkPrefix }) => {
  const {
    // State
    showSecondaryNav,
    shouldSlide,
    currentSelection,
    selectedSubCategory,

    // Handlers
    handleSubCategoryClick,
    handleBackClick,
    handleLocationChange,

    // Derived data
    groupedColumns,

    // Refs
    wrapperRef,
  } = useTopNavItems({ skuCategoriesAndSkus, toggleTopnav });

  const contentStyles = cn(styles.slideContentWrapper, {
    [styles.slideIn]: showSecondaryNav,
    [styles.slideOut]: shouldSlide && !showSecondaryNav,
  });

  return (
    <section ref={wrapperRef} className={styles.navContainer}>
      <div className={contentStyles}>
        <div
          className={styles.overflowContainer}
          data-testid="navigation-menu-sku-categories-container"
        >
          <NavHeader
            currentItem={currentSelection}
            showSecondaryNav={showSecondaryNav}
            onBackClick={handleBackClick}
          />
          <Grid.FullWidth classes="marginAuto">
            <Grid.Row classes={cn('paddingTop-medium', styles.menuRow)}>
              {showSecondaryNav ? (
                <SecondaryMenu
                  skuLinkPrefix={skuLinkPrefix}
                  category={currentSelection[1]}
                  onSecondaryMenuItemClick={handleLocationChange}
                  selectedSubCategory={selectedSubCategory}
                />
              ) : (
                <PrimaryMenu
                  skuLinkPrefix={skuLinkPrefix}
                  groupedColumns={groupedColumns}
                  handleSubCategoryClick={handleSubCategoryClick}
                  onPrimaryMenuItemClick={handleLocationChange}
                />
              )}
            </Grid.Row>
          </Grid.FullWidth>
        </div>
      </div>
    </section>
  );
};

TopNavItems.propTypes = {
  skuCategoriesAndSkus: PropTypes.array,
  toggleTopnav: PropTypes.func,
  skuLinkPrefix: PropTypes.string,
  topNavIsOpen: PropTypes.bool,
};
export default React.memo(TopNavItems);
